import type { AdsPanelProps } from './components/AdsPanel';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "AdsPanel" */ './lazyIndex'),
    {
        name: 'AdsPanel',
    }
);

export const AdsPanel: LazyComponent<AdsPanelProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.AdsPanel
);
